<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4"
  (click)="onClose()">
  <div class="bg-white dark:bg-slate-900 w-full max-w-2xl rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <h3 class="text-base font-extrabold text-slate-800 dark:text-slate-100">
        {{ isEdit ? 'แก้ไขอัตราค่าบริการ' : 'เพิ่มอัตราค่าบริการ' }}
      </h3>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 rounded-xl text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer border-none bg-transparent">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <div class="p-6 space-y-4 max-h-[75vh] overflow-y-auto custom-scrollbar" *ngIf="!isLoading(); else loadingTpl">
      <div class="text-xs font-semibold text-slate-500">
        ลาน: <span class="text-slate-800 dark:text-slate-200">{{ siteName || formData.siteName || '-' }}</span>
      </div>

      <div class="space-y-1.5">
        <label class="text-xs font-bold text-slate-500">
          รหัสอัตรา (rate_id) <span class="text-rose-500">*</span>
          <span class="font-medium text-slate-400">— จาก Main Rate</span>
        </label>
        <select [(ngModel)]="formData.rateId"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200">
          <option [ngValue]="''">— เลือก Main Rate —</option>
          <option *ngIf="hasOrphanRateId" [ngValue]="formData.rateId">
            {{ formData.rateId }} (ไม่พบใน Main Rate)
          </option>
          <option *ngFor="let opt of mainRateOptions" [ngValue]="opt.mainRateId">
            {{ opt.mainRateId }}{{ opt.name ? ' — ' + opt.name : '' }}
          </option>
        </select>
        <p *ngIf="mainRateOptions.length === 0" class="text-[11px] font-medium text-amber-600">
          ยังไม่มี Main Rate — ไปสร้างที่เมนู Parking Main Rate ก่อน
        </p>
      </div>

      <div class="space-y-1.5">
        <label class="text-xs font-bold text-slate-500">ชื่อ <span class="text-rose-500">*</span></label>
        <input type="text" [(ngModel)]="formData.name" placeholder="ชื่ออัตราค่าบริการ"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
      </div>

      <div class="space-y-1.5">
        <label class="text-xs font-bold text-slate-500">Detail</label>
        <textarea [(ngModel)]="formData.detail" rows="3" placeholder="รายละเอียดเพิ่มเติม"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 resize-none"></textarea>
      </div>

      <div class="space-y-1.5">
        <label class="text-xs font-bold text-slate-500">Free time (นาที)</label>
        <input type="number" [(ngModel)]="formData.freeTime" min="0" placeholder="0"
          class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
      </div>

      <!-- ── ส่วนลด / แสตมป์ ── -->
      <div class="pt-2 border-t border-slate-100 dark:border-slate-800 space-y-3">
        <div class="flex items-center gap-2 text-sm font-extrabold text-slate-700 dark:text-slate-200">
          <span class="material-icons-outlined text-[18px] text-amber-500">sell</span>
          ส่วนลด และการส่งไป Taiwan
        </div>

        <label class="flex items-start gap-3 p-3 rounded-2xl border cursor-pointer transition-colors"
          [ngClass]="formData.discount ? 'border-amber-300 bg-amber-50/60 dark:bg-amber-900/10' : 'border-slate-200 dark:border-slate-700'">
          <input type="checkbox" [(ngModel)]="formData.discount"
            class="mt-0.5 w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-200 cursor-pointer" />
          <span class="flex-1">
            <span class="block text-sm font-bold text-slate-700 dark:text-slate-200">เป็นส่วนลด / แสตมป์</span>
            <span class="block text-[11px] text-slate-500">เปิดแล้วเรทนี้จะให้เลือกได้ตอน Apply Stamp</span>
          </span>
        </label>

        <label class="flex items-start gap-3 p-3 rounded-2xl border cursor-pointer transition-colors"
          [ngClass]="formData.splitByVehicleType ? 'border-amber-300 bg-amber-50/60 dark:bg-amber-900/10' : 'border-slate-200 dark:border-slate-700'">
          <input type="checkbox" [ngModel]="formData.splitByVehicleType" (ngModelChange)="onSplitToggle($event)"
            class="mt-0.5 w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-200 cursor-pointer" />
          <span class="flex-1">
            <span class="block text-sm font-bold text-slate-700 dark:text-slate-200">แยกส่วนลด Taiwan ตามประเภทรถ</span>
            <span class="block text-[11px] text-slate-500">
              ใช้เมื่อ Taiwan ตั้งจำนวนเงินส่วนลดต่างกันตามประเภทรถ — ระบบจะดูประเภทรถจากรายการจอดแล้วเลือกกฎให้เอง
            </span>
          </span>
        </label>

        <!-- ไม่แยกประเภท: กฎเดียวใช้กับทุกคัน -->
        <div *ngIf="!formData.splitByVehicleType" class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <app-pss-searchable-picker label="ส่วนลด Taiwan" icon="sell" placeholder="ค้นหาส่วนลด..."
            [selectedId]="ruleValue('discount1')" [displayText]="ruleName('discount1')"
            [options]="ruleOptions.discount1" [total]="ruleOptions.discount1.length" [previewSize]="500"
            (searchChange)="onRuleSearch('discount1', $event)" (optionSelected)="onRuleSelected('discount1', $event)"
            (cleared)="onRuleCleared('discount1')"></app-pss-searchable-picker>
          <app-pss-searchable-picker label="ค่าปรับ Taiwan (ถ้ามี)" icon="gavel" placeholder="ค้นหาค่าปรับ..."
            [disabled]="!ruleValue('discount1')"
            [selectedId]="ruleValue('fine1')" [displayText]="ruleName('fine1')"
            [options]="ruleOptions.fine1" [total]="ruleOptions.fine1.length" [previewSize]="500"
            (searchChange)="onRuleSearch('fine1', $event)" (optionSelected)="onRuleSelected('fine1', $event)"
            (cleared)="onRuleCleared('fine1')"></app-pss-searchable-picker>
        </div>

        <!-- แยกประเภท: การ์ดละประเภทรถ -->
        <div *ngIf="formData.splitByVehicleType" class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div *ngFor="let cat of [1, 2]"
            class="p-3 rounded-2xl border border-slate-200 dark:border-slate-700 bg-slate-50/40 dark:bg-slate-800/30 space-y-3">
            <div class="flex items-center gap-2">
              <span class="w-7 h-7 rounded-lg bg-amber-400 text-slate-900 flex items-center justify-center shrink-0">
                <span class="material-icons text-[17px]">{{ cat === 1 ? 'directions_car' : 'two_wheeler' }}</span>
              </span>
              <div class="min-w-0">
                <div class="text-sm font-bold text-slate-700 dark:text-slate-200 truncate">{{ categoryLabel(cat) }}</div>
                <div class="text-[10.5px] text-slate-400">Taiwan car_category {{ cat }}</div>
              </div>
            </div>
            <ng-container *ngIf="cat === 1">
              <app-pss-searchable-picker label="ส่วนลด" icon="sell" placeholder="ค้นหาส่วนลด..."
                [selectedId]="ruleValue('discount1')" [displayText]="ruleName('discount1')"
                [options]="ruleOptions.discount1" [total]="ruleOptions.discount1.length" [previewSize]="500"
                (searchChange)="onRuleSearch('discount1', $event)" (optionSelected)="onRuleSelected('discount1', $event)"
                (cleared)="onRuleCleared('discount1')"></app-pss-searchable-picker>
              <app-pss-searchable-picker label="ค่าปรับ (ถ้ามี)" icon="gavel" placeholder="ค้นหาค่าปรับ..."
                [disabled]="!ruleValue('discount1')"
                [selectedId]="ruleValue('fine1')" [displayText]="ruleName('fine1')"
                [options]="ruleOptions.fine1" [total]="ruleOptions.fine1.length" [previewSize]="500"
                (searchChange)="onRuleSearch('fine1', $event)" (optionSelected)="onRuleSelected('fine1', $event)"
                (cleared)="onRuleCleared('fine1')"></app-pss-searchable-picker>
            </ng-container>
            <ng-container *ngIf="cat === 2">
              <app-pss-searchable-picker label="ส่วนลด" icon="sell" placeholder="ค้นหาส่วนลด..."
                [selectedId]="ruleValue('discount2')" [displayText]="ruleName('discount2')"
                [options]="ruleOptions.discount2" [total]="ruleOptions.discount2.length" [previewSize]="500"
                (searchChange)="onRuleSearch('discount2', $event)" (optionSelected)="onRuleSelected('discount2', $event)"
                (cleared)="onRuleCleared('discount2')"></app-pss-searchable-picker>
              <app-pss-searchable-picker label="ค่าปรับ (ถ้ามี)" icon="gavel" placeholder="ค้นหาค่าปรับ..."
                [disabled]="!ruleValue('discount2')"
                [selectedId]="ruleValue('fine2')" [displayText]="ruleName('fine2')"
                [options]="ruleOptions.fine2" [total]="ruleOptions.fine2.length" [previewSize]="500"
                (searchChange)="onRuleSearch('fine2', $event)" (optionSelected)="onRuleSelected('fine2', $event)"
                (cleared)="onRuleCleared('fine2')"></app-pss-searchable-picker>
            </ng-container>
          </div>
        </div>

        <!-- สรุปผลตอน Apply Stamp -->
        <div class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 p-3 space-y-2">
          <div class="text-[11px] font-bold text-slate-500 flex items-center gap-1.5">
            <span class="material-icons-outlined text-[15px]">send</span>
            ตอน Apply Stamp ที่ลาน Taiwan ระบบจะส่ง
          </div>
          <div *ngIf="!formData.discount" class="text-[11px] text-amber-600 flex items-center gap-1.5">
            <span class="material-icons-outlined text-[14px]">info</span>
            ยังไม่ได้เปิด "เป็นส่วนลด / แสตมป์" — เรทนี้จะยังไม่แสดงตอน Apply Stamp
          </div>
          <div *ngFor="let row of applyPreview" class="flex items-start gap-2 text-xs">
            <span class="font-bold text-slate-600 dark:text-slate-300 min-w-[96px] shrink-0">{{ row.label }}</span>
            <span class="material-icons text-[14px] text-slate-400 mt-px">arrow_forward</span>
            <span *ngIf="row.discountName; else noRule" class="text-slate-700 dark:text-slate-200">
              {{ row.discountName }}
              <span *ngIf="row.fineName" class="text-slate-400"> + ค่าปรับ {{ row.fineName }}</span>
            </span>
            <ng-template #noRule>
              <span class="text-rose-500">ยังไม่ตั้ง — ให้ส่วนลดรถประเภทนี้ไม่ได้</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <ng-template #loadingTpl>
      <div class="p-10 text-center text-slate-400 text-sm">กำลังโหลด...</div>
    </ng-template>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-between gap-3">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50 shrink-0">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex gap-3 flex-1 justify-end">
        <button type="button" (click)="onClose()" [disabled]="isSaving()"
          class="flex-1 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 cursor-pointer bg-transparent disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
          class="flex-1 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-black cursor-pointer border-none disabled:opacity-50">
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingRate"
  [entityId]="itemId"
  title="ประวัติอัตราค่าบริการ"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
